import * as React from "react";
import {
    Form, Formik, FormikHelpers
} from "formik";

import SquareButton from "../Buttons/SquareButton";
import { TrackingObject } from "../../types/TrackingTypes";
import { EmailField, validateEmail } from "../EmailField/EmailField";
import styles from "./NewsletterModal.module.scss";

interface NewsletterFormValues {
    email: string;
}

interface NewsletterFormProps {
    onFormSubmit: (formData: object) => Promise<boolean>;
    submitTrackingProps?: TrackingObject;
}

const ErrorMessage = (props: React.HTMLProps<HTMLDivElement>) => {
    const { className } = props;
    return (
        <div className={className}>
            Something went wrong. Please contact
            {" "}
            <a href="/contact">support</a>
            .
        </div>
    );
};

const NewsletterForm = (props: NewsletterFormProps) => {
    const { onFormSubmit, submitTrackingProps } = props;
    const [showErrorMessage, setShowErrorMessage] = React.useState(false);

    const initialValues: NewsletterFormValues = {
        email: ""
    };

    const validateForm = (values: NewsletterFormValues) => {
        const errors: { [k: string]: string } = {};

        if (!values.email) {
            errors.email = "Email Required";
        } else if (!validateEmail(values.email)) {
            errors.email = "Invalid email address";
        }
        return errors;
    };

    // eslint-disable-next-line max-len
    const handleFormSubmit = async (values: NewsletterFormValues, formikHelpers: FormikHelpers<NewsletterFormValues>) => {
        onFormSubmit(values).then((isSuccess) => {
            setShowErrorMessage(!isSuccess);
            // Enable the submit button after handling the formSubmit callback
            formikHelpers.setSubmitting(false);
        });
    };

    return (
        <Formik initialValues={initialValues} onSubmit={handleFormSubmit} validate={validateForm}>
            {({
                values, errors, touched, handleChange, handleSubmit, isSubmitting
            }) => (
                <Form
                    onSubmit={handleSubmit}
                    className={styles.form}
                    noValidate={true}
                    aria-label="Newsletter Sign Up Form"
                    data-tracking-props={JSON.stringify(submitTrackingProps)}
                    data-tracking-event-type="modal_action"
                >
                    <EmailField
                        name="email"
                        label="Email Address"
                        type="email"
                        value={values.email}
                        onChange={handleChange}
                        id="email"
                        fieldErrors={errors.email && touched.email ? [errors.email] : []}
                        placeholder="Enter your email"
                        className={styles.emailField}
                    />
                    <SquareButton
                        color="secondary-100"
                        type="submit"
                        disabled={isSubmitting}
                        data-tracking-props={JSON.stringify(submitTrackingProps)}
                        data-tracking-event-type="modal_action"
                        className={styles.submitButton}
                    >
                        Subscribe
                    </SquareButton>
                    {showErrorMessage && <ErrorMessage className={styles.error} />}
                </Form>
            )}
        </Formik>
    );
};

export { NewsletterForm };
